export async function getOffers(booking:Booking) {
    console.log('get-offers.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'offers';

    let data = new FormData();
    data.append('booking', JSON.stringify(booking));

    return await fetch(reactAppData.api_url+endPoint, {body: data, method: 'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return {error: error}
            }
        );
}

export function get_active_sidebar_campaigns (booking:Booking, offers:any) {
    let campaigns:any = []

    if(booking.isLastMinute) {
        campaigns = [booking.isLastMinuteMessage];
    }

    if(!offers) {
        return []
    }

    offers = approveOffers(booking, offers)
    for(let i=0; i<offers.length; i++){
        const offer = offers[i]
        if(offer['sidebar_service'] && offer['active']) {
            campaigns.push(offer.sidebar_service)
        }
    }

    return campaigns
}

export function approveOffers(booking:Booking, offers:any) {

    let approvedOffers = []
    let masterOffers = [0]

    for(let i=0; i<offers.length; i++){
        let approved = true
        const offer = offers[i]

        // Approve car brand
        approved = _approveBrand(approved, offer.requirement.car, booking.car.brand)

        // Approve car reg
        approved = _approveReg(approved, offer.requirement.reg, booking.car.reg)

        // Approve car year model
        approved = _approveYear(approved, offer.requirement.year, booking.car.year)

        // Approve workshop
        approved = _approveWorkshop(approved, offer.requirement.workshop, booking.workshop)

        // Offer active for service type
        offer.active = _activeForService(offer.requirement.service, booking.serviceArray)

        // Offer active for option
        offer.active = _activeForOption(offer.active, offer.requirement.option, booking.options)

        if (approved) {
            if(offer.requirement.master) // Collect master offers
                masterOffers = masterOffers.concat(offer.requirement.master)

            approvedOffers.push(offer)
        }
    }

    // Remove offers, which has a master offer
    for(let i=0; i<approvedOffers.length; i++){
        if(masterOffers.includes(approvedOffers[i].id))
            approvedOffers.splice(i, 1)
    }

    return approvedOffers;
}

function _approveBrand (approved:boolean, approvedBrands:any, brand:string) {
    if(!approved)
        return approved

    if(approvedBrands.length > 0)
        approved = approvedBrands.includes(brand.toLowerCase())

    return approved
}

function _approveReg (approved:boolean, approvedRegs:any, reg:string) {
    if(!approved)
        return approved

    if(approvedRegs.length > 0)
        approved = approvedRegs.includes(reg)

    return approved
}

function _approveYear (approved:boolean, approvedYears:any, year:string) {
    if(!approved)
        return approved

    if(approvedYears.length > 0)
        approved = approvedYears.includes(parseInt(year))

    return approved
}

function _approveWorkshop (approved:boolean, approvedWorkshops:any, workshop:number) {
    if(!approved)
        return approved // false

    if(approvedWorkshops.length > 0) {
        if(!workshop)
            return false

        approved = approvedWorkshops.includes(workshop.toString())
    }

    return approved
}

function _activeForService (activeForServices:any, services:any) {

    if(activeForServices.length === 0)
        return true

    for (let i=0; i<services.length; i++){
        if(activeForServices.includes(services[i].product_id.toString()))
            return true
    }

    return false
}

function _activeForOption (active:boolean, activeForOptions:any, options:any) {

    if(!active)
        return active // false

    if(!activeForOptions)
        return true

    for (let i=0; i<options.length; i++){
        for (let ii=0; ii<activeForOptions.length; ii++) {
            if(options[i].id === parseInt(activeForOptions[ii].for_option))
                return true
        }
    }

    return false
}
